// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--2R8Y7","cardWithPadding":"Card-module--card--with-padding--2sTdw","cardReducedMargin":"Card-module--card--reduced-margin--3Os0t"};